import Image from "next/image";

type RatingProps = {
  rating: number;
};

const Rating = ({ rating }: RatingProps) => {
  const fullStars = Math.floor(rating / 2);
  const halfStar = rating % 2 >= 0.5;
  return (
    <div className="flex">
      {[...Array(5)].map((_, i) => (
        <Image
          key={i}
					alt="Rental company rating star"
          height={20}
          width={20}
          src={`${
            i < fullStars
              ? "/rental-ratings/full-star"
              : i === fullStars && halfStar
              ? "/rental-ratings/half-star"
              : "/rental-ratings/empty-star"
          }.svg`}
        />
      ))}
    </div>
  );
};

export default Rating;
